import { useState } from "react";
import { useTranslation } from "react-i18next";
import { registerOrganization } from "../../api/Services";
import CheckEmail from "../checkemail/CheckEmail";

import { Alert, Button, Form, Input, Spin, Typography } from "antd";
import {
  UserOutlined,
  EditOutlined,
  HomeOutlined,
  LoadingOutlined,
} from "@ant-design/icons";

import styles from "./SignupForm.module.scss";

const SignupForm = () => {
  const { t } = useTranslation();

  const [completed, setCompleted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [email, setEmail] = useState("");
  const [organizationName, setOrganizationName] = useState("");

  const [form] = Form.useForm();

  const onFinish = async (data: any) => {
    const organizationName = data.organizationName.trim().toLowerCase();

    setLoading(true);

    let response = await registerOrganization(
      organizationName,
      data.email,
      data.password
    );
    if (response) {
      form.resetFields();
      setEmail(data.email);
      setOrganizationName(organizationName);
      setCompleted(true);
    } else {
      setError(true);
      setErrorMessage("Hubo un error"); //deberia ser de la api
    }

    setLoading(false);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return !completed ? (
    <div className={styles.container}>
      <div className={styles.formWrapper}>
        <div className={styles.header}>
          <Typography.Title level={2} className={styles.title}>
            {t("Common-Register")}
          </Typography.Title>
          <Typography.Text className={styles.subtitle}>
            {t("Common-EnterOrganization")}
          </Typography.Text>
        </div>

        <Form
          name="signup"
          form={form}
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          className={styles.form}
        >
          <Form.Item
            label={t("Common-OrganizationName")}
            name="organizationName"
            rules={[
              {
                required: true,
                message: t("Common-OrganizationNameNotEntered"),
              },
              {
                pattern: /^[a-z0-9]+$/i,
                message: t("Common-OrganizationNameSpecialCharacters"),
              },
            ]}
            className={styles.formItem}
          >
            <Input
              prefix={<HomeOutlined className={styles.inputIcon} />}
              placeholder={t("Common-OrganizationName")}
              className={styles.input}
            />
          </Form.Item>

          <Form.Item
            label={t("Common-Email")}
            name="email"
            rules={[
              {
                required: true,
                type: "email",
                message: t("Common-EmailNotEntered"),
              },
            ]}
            className={styles.formItem}
          >
            <Input
              prefix={<UserOutlined className={styles.inputIcon} />}
              placeholder={t("Common-Email")}
              className={styles.input}
            />
          </Form.Item>

          <Form.Item
            label={t("Common-Password")}
            name="password"
            rules={[
              { required: true, min: 8, message: t("Common-PasswordLength") },
            ]}
            className={styles.formItem}
          >
            <Input.Password
              prefix={<EditOutlined className={styles.inputIcon} />}
              placeholder={t("Common-Password")}
              className={styles.input}
            />
          </Form.Item>

          {error && (
            <Alert
              message="Error"
              description={errorMessage}
              type="error"
              showIcon
              className={styles.alert}
            />
          )}

          <Form.Item className={styles.buttonItem}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={loading}
              className={styles.submitButton}
              block
            >
              {loading ? (
                <Spin
                  indicator={<LoadingOutlined className="ol-loading-spin-icon" />}
                  delay={500}
                />
              ) : (
                t("Common-Register")
              )}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  ) : (
    <CheckEmail email={email} organizationName={organizationName} />
  );
};

export default SignupForm;
